export default __webpack_public_path__ + "static/media/ttmikbooks_02.6bac48b2.jpg";